import { Component, Inject, OnInit, ViewChild, ViewChildren} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { StateService } from '../../../../../services/state.service';
import { forkJoin, of } from 'rxjs';
import { cloneDeep } from 'lodash';
import { AuthService } from '../../../../../core/auth';
import { AppService } from '../../../../../services/app.service';

@Component({
  selector: 'kt-confirm',
  templateUrl: './modif-user-dialog.component.html',
  styleUrls: ['./modif-user-dialog.component.scss']
})
export class ModifUserDialog implements OnInit {

@ViewChildren('elseBlock') imgSignatureUrl: any;

  user: any;
  userParams: any={};
  loading: boolean = false;
  errors:any = [];
  errorMessage:any = null;
  displayTab:String = 'infos';
  dateInput: any;
  url_signature_upload: string;
  public editorDisabled = false;
  notUploaded: boolean = true;

  result: any = {
    documents: [],
    currentEtat: "0",
    archive : 'false',
    selectedDocument: null
  };
  public config: any = {
	lang: "fr-FR",  
    airMode: false,
    tabDisable: false,
    popover: {
   
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            
          ]
        ]
      ]
    },
    
    toolbar: [
      
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
        //   'strikethrough',
        //   'superscript',
        //   'subscript',
        //   'clear'
        ]
      ],
      
      ['para', ['ul', 'ol']],
      ['insert', ['table', 'picture', 'link']],
      
    ],
    // fontSizes: ['8','9','10','11','12','14','18','24','36','44','56','64','76','84','96'],
    fontNames: ['Arial', 'Times New Roman','Inter', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times', 'MangCau', 'BayBuomHep','BaiSau','BaiHoc','CoDien','BucThu', 'KeChuyen', 'MayChu', 'ThoiDai', 'ThuPhap-Ivy', 'ThuPhap-ThienAn'],
    // buttons: {
    //   testBtn: customButton
    // },
    codeviewFilter: false,
    //codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: false
  };

  inputDisabled: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ModifUserDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private authService: AuthService,
    private stateService : StateService,
    private router: Router,
    private snackbar : MatSnackBar

  ) { }

  ngOnInit() {
    if (this.data) {
        if(this.data.user){
            this.user = this.data.user;
           /* let signatureText = this.user.signature_text.split("<p>");
            let transition = signatureText[1].split("</p>");
            signatureText = transition[0];
            transition = signatureText.split("<br>");
            signatureText = transition[0];*/
            this.userParams={
                "nom":this.user.nom,
                "prenom":this.user.prenom,
                "sexe":this.user.sexe,
                "nomMarital":this.user.nomMarital,
                "naissance": this.user.naissance? this.user.naissance.date:"",
                "signature": this.user.signature,
                "signature_url": this.user.signature_url,
                "signature_text": this.user.signature_text,
                "signature_etat": this.user.signature_etat,
            };
        }
    }
    console.log("userParams:",this.userParams);
    this.dateInput = new Date(this.userParams.naissance);
  }

  ngAfterViewInit() {
    if (this.imgSignatureUrl!=undefined
    && this.imgSignatureUrl.first!=undefined
    ){
        this.imgSignatureUrl.first.nativeElement.onerror = () => {
            if(this.userParams.signature != ""){
                console.log("Erreur de chargement de l'image.");
                let signature_url = this.userParams.signature_url.split("?nocrypt=1");
                this.userParams.signature_url = signature_url[0];
            }
        }
    }
   
  }

  updateDate(event: any) {
    this.userParams.naissance = event.value.toLocaleDateString("fr");
  }
 
  submit(){
    if (this.setErrors().length == 0) {
        this.loading = true;
        const modifTiersObservable = this.checkUserInfoChange()
            ? this.appService.modifTiers(this.user.id, this.checkUserInfoChange())
            : of(true);
        forkJoin([modifTiersObservable]).subscribe(([modifTiersRes]) => {
            this.authService.getUserByToken().subscribe((newUser: any) => {
            console.log("submit newUser:",newUser);
            if (newUser) {
                let _user = cloneDeep(this.user);
                _user.fullname = newUser.nom + " " + newUser.prenom;
                _user.nom = newUser.nom;
                _user.prenom = newUser.prenom;
                _user.sexe = newUser.sexe;
                _user.nomMarital = newUser.nomMarital;
                _user.naissance = newUser.naissance;
                _user.signature_text = newUser.signature_text;
                _user.signature = newUser.signature;
                _user.signature_url= newUser.signature_url;
                this.stateService.updateUser(_user);
                this.router.navigateByUrl('/home');
                this.dialogRef.close();
            }
            this.loading = false;
            });
        });
    }
}

setErrors(){
    this.userParams.nom = this.userParams.nom.trim();
    this.errors = [];
    if(this.userParams.nom.length == 0){
        this.errors.push("Le nom est vide");
    }
    if(this.userParams.sexe.length == 0){
        this.errors.push("Le sexe est vide");
    }
    this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
    return this.errors;
}
checkUserInfoChange() {
    var checkedParams: any = {};
    if (this.userParams.nom !== this.user.nom) {
      checkedParams.nom = this.userParams.nom;
    }
    if (this.userParams.prenom !== this.user.prenom) {
      checkedParams.prenom = this.userParams.prenom;
    }
    if (this.userParams.sexe !== this.user.sexe) {
      checkedParams.sexe = this.userParams.sexe;
    }
    if (this.userParams.nomMarital !== this.user.nomMarital) {
        checkedParams.nomMarital = this.userParams.nomMarital;
    }
    if ("<p>"+this.userParams.signature_text+"</p>" !== this.user.signature_text) {
        checkedParams.signature_text = "<p>"+this.userParams.signature_text+"</p>";
    }
    if (this.userParams.signature !== this.user.signature) {
        checkedParams.signature = this.userParams.signature;
        checkedParams.signature_url = this.userParams.signature_url;
    }
    if(this.user.naissance != null ){
        if (this.userParams.naissance !== this.user.naissance.date) {
            checkedParams.naissance = this.formatDateString(this.userParams.naissance);
        }
    }else{
        if( this.userParams.naissance){
            checkedParams.naissance = this.userParams.naissance;
        }
    }
   
    console.log("checkedParams", checkedParams);
    if (Object.keys(checkedParams).length === 0) {
      checkedParams = null;
    }
    return checkedParams;
}

deleteFile(){
    this.userParams.signature = "";
    this.userParams.signature_url = "";
}

formatDateString(date: string){
    if(date != ""){
        var tab = date.split("/");
        var jour = tab[0].substring(0,2);
        var mois = tab[1];
        var annee = tab[2];

        var fullDate = annee+"-"+mois+"-"+jour;
    }else{
        var fullDate = "";
    }
    return fullDate;
}

uploadFile(event,documentselected) {
    console.log("uploadFile event:",event);
    const element = event[0];
    if(this.checkFileSize(element.size, 25)){
      console.log("fichier inférieur a 25mo")
      this.appService.uploadDocument(element).subscribe((res) => {
        console.log("uploadFile res:",res);
        this.notUploaded = false;
        this.result.selectedDocument = res;
        this.userParams.signature = res.file;
        this.userParams.signature_url = res.url;
      });
    }
    else
    {
      console.log("fichier supérieur à 25mo");
      this.snackbar.open("Taille de fichier supérieur à 25mo", "", {
        duration: 5000,
        panelClass: ["error-snackbar"]
      });
    }
}


checkFileSize(fsize: any, sizelimit) {
    const file = (fsize / 1048576).toFixed(2);
    console.log(fsize, file);
    if(file >= sizelimit)
      return false;
    else
      return true;
  }

}
